import script from "./lyworkflowDesign.vue?vue&type=script&setup=true&lang=js"
export * from "./lyworkflowDesign.vue?vue&type=script&setup=true&lang=js"

import "./lyworkflowDesign.vue?vue&type=style&index=0&id=f780cc50&lang=scss"

const __exports__ = script;

export default __exports__